import React from 'react';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';

const AddNewButton = ({
    addItem,
    itemName,
    disabled
}) => (
    <Row>
        <Col className="pt-1" xs="auto">
            <div className="action-button add-button"
                disabled={disabled}
                onClick={disabled ? null : addItem}
            >
                <img src="/images/plus.svg" />
                <div className="d-inline-block pl-1 align-middle">Add {itemName}</div>
            </div>
        </Col>
    </Row>
);


AddNewButton.defaultProps = {
    disabled: false
}

AddNewButton.propTypes = {
    addItem: PropTypes.func.isRequired,
    itemName: PropTypes.string.isRequired
};

export default AddNewButton;